import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SimpleTabSideList from 'common/components/tab/SimpleTabSideList'

const getId = (id) => id ?? (globalThis.crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2))

const TabsSideBar = ({
    tabs = [],
    onChangeTab = () => {},
    defaultTab,
    fitContent = false,
}) => {
    const tabsList = tabs.map(t => ({ ...t, id: getId(t.id) }))

    const tabsFormatted = useMemo(() => tabsList.map(({ title, icon, id, count, countLabel, date, bugCount }) => ({
        icon,
        constant: id,
        label: title,
        count,
        countLabel,
        date,
        bugCount,
    })), [tabsList])

    const currentTab = defaultTab ?? tabsList[0]?.id ?? 0

    return (
        <SimpleTabSideList
            defaultTab={currentTab}
            tabs={tabsFormatted}
            onChangeTab={onChangeTab}
            fitContent={fitContent}
        >
            {tabId => (tabsList.find(({ id }) => id === tabId)?.content)}

        </SimpleTabSideList>
    )
}

TabsSideBar.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.node,
        countLabel: PropTypes.string,
        content: PropTypes.element,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })),
    onChangeTab: PropTypes.func,
    defaultTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fitContent: PropTypes.bool,
}

export default TabsSideBar
